import { Button, Text } from '@janeapp/burrito-design-system';
import {
  appendDiscoveryTokenToBookingUrl,
  formatAddress,
} from '~/utilities/helpers';
import { analytics, trackEvent, useAnalytics } from '~/hooks';
import { Marker as MarkerType } from '@googlemaps/markerclusterer';
import { InfoWindow } from '@vis.gl/react-google-maps';

interface InfoWindowProps {
  anchor: MarkerType | null;
  clinicName: string;
  bookingUrl?: string;
  phone?: string;
  streetAddress?: string;
  streetAddress2?: string;
  city?: string;
  province?: string;
}
export const MarkerInfoWindow = ({
  anchor,
  clinicName,
  bookingUrl,
  phone,
  streetAddress,
  streetAddress2,
  city,
  province,
}: InfoWindowProps) => {
  useAnalytics();
  const rudderstackSessionId = analytics?.getSessionId()?.toString() || '';

  const handleViewBookingSite = () => {
    trackEvent('mpl_view_booking_site_button_clicked', {
      clinic_name: clinicName,
      url: bookingUrl,
    });
    window.open(
      appendDiscoveryTokenToBookingUrl(bookingUrl, rudderstackSessionId),
      '_blank'
    );
  };

  return (
    <InfoWindow
      anchor={anchor}
      headerDisabled
      maxWidth={280}
      pixelOffset={[0, -5]}
      ariaLabel="Clinic info window"
    >
      <div
        data-testid="info-window"
        className="flex flex-col gap-1 pb-2 pl-2 pr-1 pt-2"
      >
        <Text size="lg" className="font-semibold">
          {clinicName}
        </Text>
        <Text className="text-md">
          {formatAddress(streetAddress2, streetAddress, city, province)}
        </Text>
        {phone && <Text className="text-md">{phone}</Text>}
        {bookingUrl && (
          <Button
            className="w-100 mt-2 text-md text-neutral-80"
            onClick={handleViewBookingSite}
          >
            View booking site
          </Button>
        )}
      </div>
    </InfoWindow>
  );
};
